import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import {
  KompisSheetBody,
  KompisSheetBodyPadding,
  KompisSheetFooter,
  KompisSheetFooterButtons
} from '@inter-ikea-kompis/react-components';
import { TopPanelSystem } from '@inter-ikea-storageone/range';
import { useCore } from 'contexts/core';
import { useAppDispatch } from 'ducks/hooks';
import addTop from 'rangeConfig/shared/behaviors/addTop';
import deleteTop from 'rangeConfig/shared/behaviors/deleteTop';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Box from 'ui/Box';
import Sheet from 'ui/Sheet/Sheet';
import SheetHeader from 'ui/Sheet/SheetHeader';
import Body from 'ui/Typography/Body';
import Title from 'ui/Typography/Title';
import TopInfoImage from '../TopInfo/topInfo.png';
import { store } from 'ducks';
import { hideTopFrameWidgetInfoSheet, isModalVisible } from './TopFrameWidgetInfoFeature';

const Image = styled.img`
  width: 100%;
`;

const TopFrameWidgetInfoSheet = () => {
  const coreApi = useCore();
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch();
  const visible = !!useSelector(isModalVisible);
  const selectedEntity = coreApi.entities.findSelectedEntity();
  const rootState = store.getState();
  const topPanelSystem = coreApi.getSystem<TopPanelSystem>('TopPanelSystem');
  const topProduct = rootState.products.inMarket.find(
    p => p.type === topPanelSystem?.topPanelProductType
  );

  const props = {
    coreProductId: topProduct?.coreProductId,
    menu: 'main_menu'
  };

  const frame =
    selectedEntity &&
    HierarchyUtils.findWithComponentInUpwardsHierarchy(
      selectedEntity,
      ComponentIds.FRAME_COMPONENT_ID
    );

  const doesFrameHasTop =
    frame &&
    topPanelSystem &&
    coreApi.entities.getChildrenWithProductType(frame, topPanelSystem?.topPanelProductType).length >
      0;

  const onBack = () => {
    dispatch(hideTopFrameWidgetInfoSheet());
  };

  const onClose = () => {
    dispatch(hideTopFrameWidgetInfoSheet());
  };

  const onButtonClick = (event: CustomEvent) => {
    if (event.detail.type === 'primaryButton' && !doesFrameHasTop) {
      addTop({ coreApi, dispatch, rootState, props });
    }
    if (event.detail.type === 'secondaryButton' && doesFrameHasTop) {
      deleteTop({ coreApi, dispatch, rootState, props });
    }
    dispatch(hideTopFrameWidgetInfoSheet());
  };

  return (
    <Sheet onOverlayClick={onClose} visible={visible}>
      <SheetHeader backIcon={true} onBackButtonClick={onBack} onCloseButtonClick={onClose} />
      <KompisSheetBody theme={SkapaTheme}>
        <KompisSheetBodyPadding theme={SkapaTheme}>
          <Title type={ThemeFontStyleTypeEnum.headingMedium}>
            {formatMessage({ id: 'storageone.platsaTopInfoSheetTitle' })}
          </Title>
          <Body type={ThemeFontStyleTypeEnum.bodyLarge}>
            {formatMessage({ id: 'storageone.platsaTopInfoSheetDescription' })}
          </Body>
          <Box mt={'l'}>
            <Image src={TopInfoImage} alt={'Top image'} />
          </Box>
        </KompisSheetBodyPadding>
      </KompisSheetBody>
      <KompisSheetFooter theme={SkapaTheme}>
        <KompisSheetFooterButtons
          theme={SkapaTheme}
          primaryLabel={formatMessage({
            id: 'storageone.platsaTopWidgetSheetPrimaryButtonLabel'
          })}
          secondaryLabel={formatMessage({
            id: 'storageone.platsaTopWidgetSheetSecondaryButtonLabel'
          })}
          onButtonClick={event => onButtonClick(event)}
        />
      </KompisSheetFooter>
    </Sheet>
  );
};

export default TopFrameWidgetInfoSheet;
